import { useSubscription } from "@apollo/client/react";

import {NEW_MESSAGE_SUBSCRIPTION} from "../constants/graphql";

export default function useAssetsImport(userId, callback) {
  return useSubscription(NEW_MESSAGE_SUBSCRIPTION, {
    variables: { userId },
    onData: ({ data: subscriptionData }) => {
      if (subscriptionData?.data?.newMessage?.text === "Assets Successfully Imported") {
        callback();
      }
    },
  });
}
